import { isAccessDeniedException, isInsufficientAuthenticationException } from "@firefly/fly-security";
export default function throwOnSecurityException(error) {
  return isInsufficientAuthenticationException(error) || isAccessDeniedException(error);
}